/**
 * Computes whether the table supports merging cells.
 *
 * This mirrors the original `TableEditable.supportsMerge()`, which checked that
 * both `tableMutations.mergeRegion` and `tableMutations.unmergeRegion` were
 * non-null. Those mutation methods are gated solely by the `disableMergingCells`
 * prop (`disableMergingCells ? null : tableOps.mergeTableRegion`), and the
 * underlying `tableOps` merge/unmerge functions are always defined. Merge is
 * therefore supported exactly when merging is not disabled.
 *
 * @param disableMergingCells - Whether merging cells is disabled for this table
 */
export function computeSupportsMerge(disableMergingCells: boolean): boolean {
  return !disableMergingCells;
}
